import { render, staticRenderFns } from "./DayOfSale.vue?vue&type=template&id=375b0aa2&"
import script from "./DayOfSale.vue?vue&type=script&lang=js&"
export * from "./DayOfSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports